/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseResponseDto_AnyResponseDto } from '../models/BaseResponseDto_AnyResponseDto';
import type { StoreChatSendDto } from '../models/StoreChatSendDto';
import type { StoreContactSubmitDto } from '../models/StoreContactSubmitDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CStoreService {
    /**
     * 联系表单提交
     * @param requestBody
     * @returns BaseResponseDto_AnyResponseDto 提交成功
     * @throws ApiError
     */
    public static storeControllerSubmitContact(
        requestBody: StoreContactSubmitDto,
    ): CancelablePromise<BaseResponseDto_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/store/contact',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 聊天消息列表（轮询），按 sessionId 返回该会话消息
     * @param sessionId 会话 id，前端生成
     * @returns BaseResponseDto_AnyResponseDto 获取成功
     * @throws ApiError
     */
    public static storeControllerGetChatMessages(
        sessionId: string,
    ): CancelablePromise<BaseResponseDto_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/store/chat/messages',
            query: {
                'sessionId': sessionId,
            },
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
    /**
     * 发送聊天消息（客户），需传 sessionId，可选 userId
     * @param requestBody
     * @returns BaseResponseDto_AnyResponseDto 发送成功
     * @throws ApiError
     */
    public static storeControllerSendChat(
        requestBody: StoreChatSendDto,
    ): CancelablePromise<BaseResponseDto_AnyResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/store/chat',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `参数错误`,
                401: `未授权`,
                403: `禁止访问`,
                404: `资源不存在`,
                500: `服务器内部错误`,
            },
        });
    }
}
